var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "none",
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0,
    d: "M10.172 4.063v9.385c0 .857-.64 1.552-1.429 1.552H2.741c-.789 0-1.429-.695-1.429-1.552V4.062"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#677177",
    d: "M10.172 4.063v9.385c0 .857-.64 1.552-1.429 1.552H2.741c-.789 0-1.429-.695-1.429-1.552V4.062M0 4h11.484M4.438 6.086v7m2.625-7v7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0,
    d: "M3.5 3.625C3.5 2.175 4.48 1 5.688 1c1.208 0 2.187 1.175 2.187 2.625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#677177",
    d: "M3.5 3.625C3.5 2.175 4.48 1 5.688 1c1.208 0 2.187 1.175 2.187 2.625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bec33303cd698a307e4c5a4ef75ebf93.svg";
export { ForwardRef as ReactComponent };